import React from 'react';
import classnames from 'classnames';

/**
 * React Label (form field) component.
 *
 * @function Label
 * @param {Object} props
 * @param {String} props.text
 * @param {String} [props.id='']
 * @param {Boolean} [props.required=false]
 * @param {String} [props.className='']
 * @param {Boolean} [props.ariaHidden=false]
 * @returns {?HTMLLabelElement}
 */
export default function Label({
  ariaHidden = false,
  className = '',
  htmlFor = '',
  required = false,
  text = '',
}) {
  if (text === '') {
    return null;
  }

  return (
    <label htmlFor={ htmlFor } aria-hidden={ ariaHidden || undefined } className={ classnames(
      'c-label',
      className,
      {'c-label--required': required}
    ) }>
      { text }
      { createAsterisk(required) }
    </label>
  );
}

/**
 * Helper function to create the label's asterisk.
 * If the label doesn't belong to a required field,
 * don't render the asterisk.
 *
 * @function createAsterisk
 * @param {Boolean} [required=false]
 * @returns {HTMLElement}
 * @private
 */
function createAsterisk(required = false) {
  if (!required) {
    return;
  }

  return (
    <span className="c-label__asterisk" aria-label="required">
      <span aria-hidden="true"> &#42;</span>
    </span>
  );
}
